// ─── 7일 추이 라인 차트 ───────────────────────────────────────────────────────
import React, { useState } from 'react';

const W   = 440, H   = 160;
const PAD = { t: 14, r: 24, b: 28, l: 36 };
const CW  = W - PAD.l - PAD.r;
const CH  = H - PAD.t - PAD.b;

/**
 * 최근 7일 전체 건수 및 오류 건수를 라인 차트로 렌더링합니다.
 * @param {{ data: Array<{label:string, n:number, error:number}> }} props
 */
export default function TrendChart({ data }) {
  const [hov, setHov] = useState(null);

  const maxN = Math.max(...data.map((x) => x.n), 1);
  const toX  = (i) => PAD.l + (i / Math.max(data.length - 1, 1)) * CW;
  const toY  = (v) => PAD.t + CH - (v / maxN) * CH;

  const pts       = data.map((x, i) => ({ x: toX(i), y: toY(x.n), ye: toY(x.error || 0), ...x }));
  const totalPoly = pts.map((p) => `${p.x},${p.y}`).join(' ');
  const errPoly   = pts.map((p) => `${p.x},${p.ye}`).join(' ');
  const area      = `${pts[0].x},${PAD.t + CH} ${totalPoly} ${pts[pts.length - 1].x},${PAD.t + CH}`;
  const yTicks    = [0, Math.ceil(maxN / 2), maxN];

  return (
    <svg viewBox={`0 0 ${W} ${H}`} className="w-full h-full" style={{ minHeight: '160px' }}>
      <defs>
        <linearGradient id="areaGrad" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%"   stopColor="#3b82f6" stopOpacity="0.14" />
          <stop offset="100%" stopColor="#3b82f6" stopOpacity="0"    />
        </linearGradient>
      </defs>

      {/* 그리드 + Y축 */}
      {yTicks.map((v, i) => (
        <g key={`ytick-${i}`}>
          <line x1={PAD.l} x2={PAD.l + CW} y1={toY(v)} y2={toY(v)} stroke="#f1f5f9" strokeWidth="1" />
          <text x={PAD.l - 4} y={toY(v) + 3} textAnchor="end" fontSize="16" fill="#cbd5e1">{v}</text>
        </g>
      ))}

      {/* 면적 */}
      <polygon points={area} fill="url(#areaGrad)" />

      {/* 전체 선 */}
      <polyline points={totalPoly} fill="none" stroke="#3b82f6" strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" />

      {/* 오류 선 (점선) */}
      <polyline points={errPoly} fill="none" stroke="#f87171" strokeWidth="1" strokeLinejoin="round" strokeLinecap="round" strokeDasharray="3 2" />

      {/* 포인트 + 툴팁 */}
      {pts.map((p, i) => (
        <g key={`pt-${i}`} onMouseEnter={() => setHov(i)} onMouseLeave={() => setHov(null)}>
          <circle cx={p.x} cy={p.y} r={hov === i ? 3.5 : 2} fill={hov === i ? '#2563eb' : '#3b82f6'} />
          <rect x={p.x - 14} y={H - PAD.b + 2} width="28" height="14" fill="transparent" />
          <text
            x={p.x} y={H - PAD.b + 13}
            textAnchor={i === 0 ? 'start' : i === data.length - 1 ? 'end' : 'middle'}
            fontSize="16" fill="#9ca3af"
          >{p.label}</text>
          {hov === i && (
            <g>
              <rect
                x={Math.min(Math.max(p.x - 44, PAD.l), W - 90)}
                y={Math.max(p.y - 52, 2)}
                width="88" height="46" rx="6" fill="#1e293b"
              />
              <text
                x={Math.min(Math.max(p.x, PAD.l + 44), W - 44)}
                y={Math.max(p.y - 33, 18)}
                textAnchor="middle" fill="white" fontSize="18" fontWeight="bold"
              >
                {p.n}건
              </text>
              <text
                x={Math.min(Math.max(p.x, PAD.l + 44), W - 44)}
                y={Math.max(p.y - 14, 36)}
                textAnchor="middle" fill="#f87171" fontSize="13"
              >
                오류 {p.error || 0}건
              </text>
            </g>
          )}
        </g>
      ))}
    </svg>
  );
}
